export default function Footer() {
  return (
    <footer id="footer" className="bg-background-100 border-t border-background-200/60">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">

          <div>
            <a href="#" className="flex items-center gap-2 mb-4 cursor-pointer">
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-film-line text-lg text-background-50"></i>
              </span>
              <span className="text-lg font-bold font-heading text-foreground-50">萝卜影视</span>
            </a>
            <p className="text-sm text-foreground-500 leading-relaxed">
              萝卜影视汇聚电影大全与最新电影上线，提供热门电影排行榜和电影在线观看高清服务，经典佳片与热映大片一网打尽。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-200 mb-4 font-heading">快速导航</h4>
            <ul className="space-y-2.5">
              <li><a href="#topics" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">热门话题</a></li>
              <li><a href="#ranking" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">热门榜单</a></li>
              <li><a href="#carousel" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">精选专题</a></li>
              <li><a href="#index" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">电影索引</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-200 mb-4 font-heading">影片分类</h4>
            <ul className="space-y-2.5">
              <li><span className="text-sm text-foreground-500">动作冒险</span></li>
              <li><span className="text-sm text-foreground-500">科幻悬疑</span></li>
              <li><span className="text-sm text-foreground-500">喜剧爱情</span></li>
              <li><span className="text-sm text-foreground-500">纪录动画</span></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-200 mb-4 font-heading">合作伙伴</h4>
            <p className="text-sm text-foreground-500 leading-relaxed">
              更多合作伙伴信息即将上线，敬请期待。
            </p>
          </div>

        </div>

        <div className="mt-12 pt-8 border-t border-background-200/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-600">
            &copy; {new Date().getFullYear()} 萝卜影视 · 电影大全与最新电影上线
          </p>
          <div className="flex items-center gap-5">
            <span className="text-xs text-foreground-600 cursor-pointer hover:text-primary-400 transition-colors">隐私政策</span>
            <span className="text-xs text-foreground-600 cursor-pointer hover:text-primary-400 transition-colors">服务条款</span>
            <span className="text-xs text-foreground-600 cursor-pointer hover:text-primary-400 transition-colors">免责声明</span>
          </div>
        </div>
      </div>
    </footer>
  );
}